import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, ViewEncapsulation, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { E11BadgeModule } from '@engineering11/ui-lib/e11-badge';

/**
 * The tabs component is used to display a list of tabs.
 *
 * @example
 * <e11-tabs-only [tabItems]="tabItems" [tabCurrent]="tabCurrent" (tabClicked)="tabClicked($event)"></e11-tabs-only>
 */
class E11TabsOnlyComponent {
    // tabCurrent: string = ''
    constructor() {
        /**
         * The list of tabs to display.
         * @type {ITabsOnly[]}
         * @default []
         */
        this.tabItems = [];
        /**
         * The current tab selected.
         * @type {string}
         * @default ''
         */
        this.tabCurrent = '';
        /**
         * The event emitted when a tab is clicked.
         * @deprecated This event is deprecated. Please use {@link onTabClick} instead.
         * @type {EventEmitter<string>}
         */
        this.tabClicked = new EventEmitter();
        /**
         * The event emitted when a tab is clicked.
         * @type {EventEmitter<string>}
         */
        this.onTabClick = new EventEmitter();
    }
    ngOnInit() {
        this.tabItems.length > 0 && !this.tabCurrent ? (this.tabCurrent = this.tabItems[0].id) : null;
    }
    selectTab(tabCurrent) {
        this.tabCurrent = tabCurrent;
        // TODO: remove this in the next major release
        this.tabClicked.emit(this.tabCurrent);
        this.onTabClick.emit(this.tabCurrent);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11TabsOnlyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11TabsOnlyComponent, isStandalone: true, selector: "e11-tabs-only", inputs: { tabItems: "tabItems", tabCurrent: "tabCurrent" }, outputs: { tabClicked: "tabClicked", onTabClick: "onTabClick" }, ngImport: i0, template: `
    <ul>
      <li
        *ngFor="let tab of tabItems"
        class="e11-float-left e11-text-xl e11-font-skin-poppins e11-mr-4 e11-font-bold e11-cursor-pointer e11-pb-1 e11-border-b-2 hover:e11-border-skin-grey"
        (click)="selectTab(tab.id)"
        [ngClass]="tab.id === tabCurrent ? 'e11-text-skin-primary-accent e11-border-skin-secondary' : 'e11-border-transparent'"
      >
        {{ tab.title }}
      </li>
    </ul>
  `, isInline: true, styles: [""], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11TabsOnlyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-tabs-only', standalone: true, imports: [CommonModule], encapsulation: ViewEncapsulation.None, template: `
    <ul>
      <li
        *ngFor="let tab of tabItems"
        class="e11-float-left e11-text-xl e11-font-skin-poppins e11-mr-4 e11-font-bold e11-cursor-pointer e11-pb-1 e11-border-b-2 hover:e11-border-skin-grey"
        (click)="selectTab(tab.id)"
        [ngClass]="tab.id === tabCurrent ? 'e11-text-skin-primary-accent e11-border-skin-secondary' : 'e11-border-transparent'"
      >
        {{ tab.title }}
      </li>
    </ul>
  ` }]
        }], ctorParameters: () => [], propDecorators: { tabItems: [{
                type: Input
            }], tabCurrent: [{
                type: Input
            }], tabClicked: [{
                type: Output
            }], onTabClick: [{
                type: Output
            }] } });

class E11TabsOnlyModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11TabsOnlyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11TabsOnlyModule, imports: [E11TabsOnlyComponent, E11BadgeModule], exports: [E11TabsOnlyComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11TabsOnlyModule, imports: [E11TabsOnlyComponent, E11BadgeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11TabsOnlyModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [E11TabsOnlyComponent, E11BadgeModule],
                    exports: [E11TabsOnlyComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11TabsOnlyComponent, E11TabsOnlyModule };
